import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlateAndFrameHeatExchanger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 120,
	viewBox: "0 0 100.0 120.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 0,
		width: 90,
		height: 120,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 15.0 0.0 L 15.0 120.0 M 25.0 0.0 L 25.0 120.0 M 35.0 0.0 L 35.0 120.0 M 45.0 0.0 L 45.0 120.0 M 55.0 0.0 L 55.0 120.0 M 65.0 0.0 L 65.0 120.0 M 75.0 0.0 L 75.0 120.0 M 85.0 0.0 L 85.0 120.0 M 0.0 3.0 L 0.0 11.0 M 0.0 109.0 L 0.0 117.0 M 100.0 3.0 L 100.0 11.0 M 100.0 109.0 L 100.0 117.0 M 0.0 7.0 L 5.0 7.0 L 95.0 113.0 L 100.0 113.0 M 0.0 113.0 L 5.0 113.0 L 95.0 7.0 L 100.0 7.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgPlateAndFrameHeatExchanger;
